import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})
export default class Overlay extends Vue {
    @Prop({ default: false }) isFullScreen!: Boolean;
    @Prop({default: 'mainContent'}) elementID!: string;

    styleObject: any = {
        height: '100%',
        width: '100%',
        top: '0px',
        left: '0px'
    }

    getSizeByElement() {
        let elem: HTMLElement | null = document.getElementById(this.elementID);

        if (elem != null && !this.isFullScreen) {
            this.styleObject.left = elem.offsetLeft;

            this.styleObject.height = elem.offsetHeight;// window.getComputedStyle(elem, null).getPropertyValue("height"); // '913px';
            this.styleObject.top = window.getComputedStyle(elem, null).getPropertyValue("padding-top"); //64px;
            this.styleObject.width = window.getComputedStyle(elem, null).getPropertyValue("width");
        }
        else {
            this.styleObject.height = '100%';
            this.styleObject.top = '0px';
            this.styleObject.width = '100%';
        }
    }

    mounted() {
        this.getSizeByElement();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/components/overlay/overlay.ts